import { Navigate, type RouteObject, useLoaderData } from 'react-router'
import LandingPageView from '@/features/iam/auth/LandingPageView/LandingPageViewContainer'
import type { IamFeature } from '@/features/iam'
import { links } from '@/utils/link'

/**
 * Routes for authentication features.
 */
export function createRoutes(iam: IamFeature): RouteObject[] {
  return [
    {
      path: '/login',
      Component: LandingPageView,
      loader: async ({ request }) => {
        if (iam.session.externalCustomerEnabled) {
          const url = iam.session.allowRequestingMagicLinks
            ? links.requestMagicLink()
            : links.sessionExpired()

          window.location.replace(url)
          return null
        }

        const isAuthenticated = await iam.authStore.checkAuthentication(
          request.signal,
        )

        if (isAuthenticated) {
          return new URL(request.url).searchParams.get('returnUrl') ?? '/'
        }

        return null
      },
    },
    {
      path: '/auth/callback',
      Component: () => <Navigate replace to={useLoaderData() ?? '/'} />,
      loader: async () => {
        const returnUrl = await iam.authStore.callback()
        return returnUrl ?? '/'
      },
    },
    {
      path: '/logout',
      Component: () => <Navigate replace to="/" />,
    },
  ]
}
